import { render, staticRenderFns } from "./spbcnWinnerCamp.vue?vue&type=template&id=f40d2736&scoped=true&"
import script from "./spbcnWinnerCamp.vue?vue&type=script&lang=js&"
export * from "./spbcnWinnerCamp.vue?vue&type=script&lang=js&"
import style0 from "./spbcnWinnerCamp.vue?vue&type=style&index=0&id=f40d2736&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40d2736",
  null
  
)

export default component.exports